import firebase from "firebase";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyA3ohrEUscIf2QBo4HpE8w9VNEDTPdkI4U",
    authDomain: "react-app-c1d18.firebaseapp.com",
    databaseURL: "https://react-app-c1d18.firebaseio.com",
    projectId: "react-app-c1d18",
    storageBucket: "",
    messagingSenderId: "735190910823"
};

firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore();
const settings = {
    timestampsInSnapshots: true
};
firestore.settings(settings);

export default firebase;
